export interface AppliedFilter {
  key: string;
  label: string;
  onRemove: () => void;
}

/** Active URL filters, shown beneath a list page's controls. */
export function AppliedFilters({ items }: { items: AppliedFilter[] }) {
  if (items.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-3" aria-label="Applied filters">
      {items.map(({ key, label, onRemove }) => (
        <button
          key={key}
          type="button"
          onClick={onRemove}
          aria-label={`Remove filter: ${label}`}
          className="flex h-[38px] cursor-pointer items-center justify-center gap-2 rounded-full border-0 bg-badge-default-bg px-4 text-[12px] leading-none font-medium text-badge-default-fg transition-colors hover:bg-badge-default-bg/80 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
        >
          <span>{label}</span>
          <span
            aria-hidden="true"
            className="flex size-5 shrink-0 items-center justify-center text-base leading-none"
          >
            ×
          </span>
        </button>
      ))}
    </div>
  );
}
